
import {
  Component,
  OnInit,
  inject,
  ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';

import {
  CupomDesconto,
  CupomDescontoRequest,
  CupomDescontoService
} from '../../../service/cupom-desconto.service';

import { QuartoService } from '../../../service/quarto.service';

@Component({
  selector: 'app-cupons',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './cupons.component.html',
  styleUrl: './cupons.component.css'
})
export class CuponsComponent implements OnInit {

  private readonly cupomService =
    inject(CupomDescontoService);

  private readonly quartoService =
    inject(QuartoService);

  private readonly cdr =
    inject(ChangeDetectorRef);

  cupons: CupomDesconto[] = [];

  quartos: any[] = [];

  carregando = false;

  modalAberto = false;

  editando = false;

  cupomSelecionado: CupomDesconto | null = null;

  formulario: CupomDescontoRequest = {
    codigo: '',
    descricao: '',
    quartosIds: [],
    tipoDesconto: 'PERCENTUAL',
    valorDesconto: 0,
    dataInicio: '',
    dataFim: '',
    limiteUtilizacoes: null,
    ativo: true
  };

  ngOnInit(): void {

    this.carregarCupons();

    this.carregarQuartos();

  }

  carregarCupons(): void {

    this.carregando = true;

    this.cdr.detectChanges();

    this.cupomService
      .listar()
      .subscribe({

        next: (cupons) => {

          this.cupons = cupons;

          this.carregando = false;

          this.cdr.detectChanges();

        },

        error: () => {

          this.carregando = false;

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível carregar os cupons.',
            confirmButtonText: 'OK'
          });

        }

      });

  }

  carregarQuartos(): void {

    this.quartoService
      .listar()
      .subscribe({

        next: (quartos) => {

          this.quartos = quartos;

          this.cdr.detectChanges();

        },

        error: () => {

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível carregar as acomodações.',
            confirmButtonText: 'OK'
          });

        }

      });

  }

  novoCupom(): void {

    this.editando = false;

    this.cupomSelecionado = null;

    this.formulario = {
      codigo: '',
      descricao: '',
      quartosIds: [],
      tipoDesconto: 'PERCENTUAL',
      valorDesconto: 0,
      dataInicio: '',
      dataFim: '',
      limiteUtilizacoes: null,
      ativo: true
    };

    this.modalAberto = true;

    this.cdr.detectChanges();

  }

  toggleQuarto(
    quartoId: number,
    selecionado: boolean
  ): void {

    if (selecionado) {

      if (!this.formulario.quartosIds.includes(quartoId)) {

        this.formulario.quartosIds = [
          ...this.formulario.quartosIds,
          quartoId
        ];

      }

      return;
    }

    this.formulario.quartosIds =
      this.formulario.quartosIds.filter(
        id => id !== quartoId
      );
  }

  editar(cupom: CupomDesconto): void {

    this.editando = true;

    this.cupomSelecionado = cupom;

    this.formulario = {
      codigo: cupom.codigo,
      descricao: cupom.descricao ?? '',
      quartosIds: cupom.quartos.map(quarto => quarto.id),
      tipoDesconto: cupom.tipoDesconto,
      valorDesconto: cupom.valorDesconto,
      dataInicio: cupom.dataInicio,
      dataFim: cupom.dataFim,
      limiteUtilizacoes: cupom.limiteUtilizacoes,
      ativo: cupom.ativo
    };

    this.modalAberto = true;

    this.cdr.detectChanges();

  }

  fecharModal(): void {

    this.modalAberto = false;

    this.cdr.detectChanges();

  }

  salvar(): void {

    if (this.editando && this.cupomSelecionado) {

      this.cupomService
        .atualizar(
          this.cupomSelecionado.id,
          this.formulario
        )
        .subscribe({

          next: () => {

            this.fecharModal();

            this.cdr.detectChanges();

            Swal.fire({
              icon: 'success',
              title: 'Cupom atualizado!',
              text: 'O cupom foi atualizado com sucesso.',
              confirmButtonText: 'OK'
            });

            this.carregarCupons();

          },

          error: (error) => {

            this.cdr.detectChanges();

            Swal.fire({
              icon: 'error',
              title: 'Erro ao atualizar',
              text:
                error?.error?.message ??
                'Não foi possível atualizar o cupom.',
              confirmButtonText: 'OK'
            });

          }

        });

      return;

    }

    this.cupomService
      .criar(this.formulario)
      .subscribe({

        next: () => {

          this.fecharModal();

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'success',
            title: 'Cupom criado!',
            text: 'O cupom foi criado com sucesso.',
            confirmButtonText: 'OK'
          });

          this.carregarCupons();

        },

        error: (error) => {

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro ao criar',
            text:
              error?.error?.message ??
              'Não foi possível criar o cupom.',
            confirmButtonText: 'OK'
          });

        }

      });

  }

  alterarStatus(cupom: CupomDesconto): void {

    const novoStatus = !cupom.ativo;

    this.cupomService
      .alterarStatus(
        cupom.id,
        novoStatus
      )
      .subscribe({

        next: () => {

          cupom.ativo = novoStatus;

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'success',
            title: 'Status atualizado!',
            text: novoStatus
              ? 'O cupom foi ativado.'
              : 'O cupom foi desativado.',
            confirmButtonText: 'OK'
          });

        },

        error: (error) => {

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text:
              error?.error?.message ??
              'Não foi possível alterar o status do cupom.',
            confirmButtonText: 'OK'
          });

        }

      });

  }

  excluir(cupom: CupomDesconto): void {

    Swal.fire({
      icon: 'warning',
      title: 'Excluir cupom?',
      text: `Deseja realmente excluir o cupom "${cupom.codigo}"?`,
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    })
      .then((resultado) => {

        if (!resultado.isConfirmed) {

          return;

        }

        this.cupomService
          .excluir(cupom.id)
          .subscribe({

            next: () => {

              this.cupons =
                this.cupons.filter(
                  item => item.id !== cupom.id
                );

              this.cdr.detectChanges();

              Swal.fire({
                icon: 'success',
                title: 'Cupom excluído!',
                text: 'O cupom foi excluído com sucesso.',
                confirmButtonText: 'OK'
              });

            },

            error: (error) => {

              this.cdr.detectChanges();

              Swal.fire({
                icon: 'error',
                title: 'Erro ao excluir',
                text:
                  error?.error?.message ??
                  'Não foi possível excluir o cupom.',
                confirmButtonText: 'OK'
              });

            }

          });

      });

  }

  formatarDesconto(cupom: CupomDesconto): string {

    if (cupom.tipoDesconto === 'PERCENTUAL') {

      return `${cupom.valorDesconto}%`;

    }

    return `R$ ${cupom.valorDesconto
  .toFixed(2)
  .replace('.', ',')}`;

  }

}
